import { combineReducers } from 'redux';

import types from './types';

const initialState = {
  isLoading: false,
  error: null,
  data: {},
};

function listUsersReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.LIST_USERS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.LIST_USERS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.LIST_USERS_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const listRolesInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function listRolesReducer(state = listRolesInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.LIST_ROLES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.LIST_ROLES_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.LIST_ROLES_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const createUserInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function createUserReducer(state = createUserInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.CREATE_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.CREATE_USER_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.CREATE_USER_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const updateMyAccountInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function updateMyAccountReducer(state = updateMyAccountInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.UPDATE_MY_ACCOUNT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_MY_ACCOUNT_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.UPDATE_MY_ACCOUNT_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const removeUserInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function removeUserReducer(state = removeUserInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.REMOVE_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.REMOVE_USER_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.REMOVE_USER_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

export default combineReducers({
  listUsers: listUsersReducer,
  listRoles: listRolesReducer,
  createUser: createUserReducer,
  updateMyAccount: updateMyAccountReducer,
  removeUser: removeUserReducer,
});
